/**
 * DIE KLADDE (NT-TUTORIAL-KLADDE-01) — Home-Panel-Widget (E6, primärer Einstiegspunkt).
 * Eingehängt im Jobs-Tab (dashboard.ts::renderJobsTab(), nur wenn jobsView === 'list').
 * Zeigt nur die offenen Punkte der aktuell sichtbaren, noch nicht abgeschlossenen Stufe.
 * Veteranen (alle Stufen komplett) sehen hier nichts — kein Dismiss-Flag nötig, folgt allein
 * aus der Ableitung. Über den Nav-/Hamburger-Eintrag bleibt die Kladde für alle jederzeit offen.
 *
 * Reines Render-Modul (kein eigenes Event-Binding) — dashboard.ts nutzt für alle Klicks im
 * `#dashboard-root` einen einzigen delegierten Handler (`handleClick()`), der `data-kladde-*`
 * dort direkt mitbehandelt (etabliertes Muster, kein Re-Binding nach jedem `renderAll()` nötig).
 */

import type { KladdeState } from '../services/kladde.js';
import { renderStagesWithHints } from '../utils/kladde-render.js';

/** Erste sichtbare, noch nicht abgeschlossene Stufe — oder null (Panel verschwindet dann). */
export function findOpenKladdeStage(state: KladdeState): KladdeState['stages'][number] | null {
  return state.stages.find((stage) => stage.visible && !stage.complete) ?? null;
}

export function renderKladdePanel(state: KladdeState): string {
  if (state.dismissed) return '';
  const openStage = findOpenKladdeStage(state);
  if (!openStage) return '';

  const done = openStage.milestones.filter((m) => m.done).length;
  const total = openStage.milestones.length;

  return `
    <section class="kladde-panel" id="kladde-panel">
      <button class="kladde-panel-header" type="button" data-kladde-toggle>
        <span class="kladde-panel-header-title">DIE KLADDE</span>
        <span class="kladde-panel-header-progress">${String(done)}/${String(total)} &#9656;</span>
      </button>
      <div class="kladde-panel-body">
        <button class="kladde-panel-dismiss" type="button" data-kladde-dismiss aria-label="Kladde ausblenden">&#10005;</button>
        ${renderStagesWithHints([openStage], state.hints)}
      </div>
    </section>
  `;
}
